import { CloseOutlined, UploadOutlined } from '@ant-design/icons'
import { Button, message, Upload } from 'antd'

import { AppAdmin } from 'api/app-admin'
import { ALLOWED_MIME_TYPES_IMAGE } from 'constants/mime-type'
import useUploadFile from 'hooks/use-upload-file'
import { generateIpfsUrl } from 'utils'
import { logError } from 'utils/logger'

interface IUploadSpecialImageProps {
  currentImage?: string
  edit: boolean
  onUploadSuccess: (filePath: string) => void
  onRemove: () => void
}

const UploadSpecialImage = ({
  currentImage,
  edit,
  onUploadSuccess,
  onRemove,
}: IUploadSpecialImageProps) => {
  const handleUpload = async (file: any) => {
    const formData = new FormData()
    formData.append('file', file)
    try {
      const response = await AppAdmin.uploadIPFS(formData)
      if (response.data.success) {
        message.success('File uploaded successfully')
        onUploadSuccess(response.data.data.cid)
      }
    } catch (error: any) {
      message.error(error?.message || 'File upload failed')
      logError('Upload error:', error)
    }
  }

  const { singleFile, handleUploadSingle, beforeUploadSingle } = useUploadFile({
    mimeTypes: ALLOWED_MIME_TYPES_IMAGE,
    onUpload: handleUpload,
  })

  const isUploading = singleFile.length > 0

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 16,
      }}
    >
      {currentImage && (
        <div style={{ position: 'relative' }}>
          <img
            src={generateIpfsUrl(currentImage) || ''}
            alt="Special"
            style={{
              width: 100,
              height: 100,
              objectFit: 'cover',
              border: '1px solid #d9d9d9',
              borderRadius: 4,
            }}
          />
          {edit && (
            <CloseOutlined
              style={{
                position: 'absolute',
                top: -8,
                right: -8,
                color: '#fff',
                fontSize: 12,
                cursor: 'pointer',
                background: '#ff4d4f',
                borderRadius: '50%',
                padding: 4,
              }}
              onClick={onRemove}
            />
          )}
        </div>
      )}
      {edit && (
        <Upload
          showUploadList={false}
          customRequest={handleUploadSingle}
          beforeUpload={beforeUploadSingle}
          accept={ALLOWED_MIME_TYPES_IMAGE.join(',')}
        >
          <Button icon={<UploadOutlined />} loading={isUploading}>
            {currentImage ? 'Change Image' : 'Upload Image'}
          </Button>
        </Upload>
      )}
    </div>
  )
}

export default UploadSpecialImage
